import { useBlockBrowserClose } from '@/hooks/useBlockBrowserClose';
import usePageTitle from '@/hooks/usePageTitle';
import { useCreateAvatarStore } from '@/pages/avatar/common/context';
import { AvatarCreateTab, AvatarType } from '@/pages/avatar/common/types';
import { ChooseVideoAvatar, ConsentStep, FootageStep, InstructionStep, WaitForUploadsStep } from '@/pages/avatar/components';
import { Header } from '@/pages/avatar/CreatePage/components';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { handleConsentStatusUpdate } from '../common/handlers';
import { useConsentNotifications } from '../hooks';

const AvatarPageContainer = styled.div`
    background-color: white;
    display: flex;
    flex-direction: column;
    height: 100vh;
    max-width: 100vw;
`;

const TITLE = 'Create Avatar - D-ID';

export const AvatarPage = observer(() => {
    const createAvatarStore = useCreateAvatarStore();
    useBlockBrowserClose(() => createAvatarStore.isDirty);
    usePageTitle(TITLE);

    useConsentNotifications(handleConsentStatusUpdate(createAvatarStore.updateSelectedConsent));

    return (
        <AvatarPageContainer>
            <Header />
            {createAvatarStore.tab === AvatarCreateTab.CHOOSE_AVATAR && <ChooseVideoAvatar />}
            {createAvatarStore.tab === AvatarCreateTab.INSTRUCTIONS && <InstructionStep />}
            {createAvatarStore.tab === AvatarCreateTab.FOOTAGE && (
                <FootageStep shouldExtendInstruction={createAvatarStore.type === AvatarType.PremiumPlus} />
            )}
            {createAvatarStore.tab === AvatarCreateTab.CONSENT && <ConsentStep />}
            {createAvatarStore.tab === AvatarCreateTab.WAIT_FOR_UPLOADS && <WaitForUploadsStep />}
        </AvatarPageContainer>
    );
});
